module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', {
    class: {
      'ql-version-fresh': _vm.fresh,
      'ql-version-editing': _vm.editing
    }
  }, [(_vm.isCurrentVersion(_vm.version.id) && !_vm.editing) ? _c('md-icon', [_vm._v("label")]) : (_vm.autoKind && !_vm.editing) ? _c('md-icon', [_vm._v("history")]) : (!_vm.editing) ? _c('md-icon', [_vm._v("label_outline")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "md-list-text-container"
  }, [(!_vm.editing) ? _c('span', {
    staticClass: "ql-version-name",
    class: {
      'ql-version-name-editable': _vm.canEditName
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.startEdit.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.displayName)), (_vm.canEditName) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v(_vm._s(_vm.autoKind ? 'Click to rename and keep' : 'Click to rename'))]) : _vm._e()], 1) : _c('form', {
    staticClass: "ql-version-rename",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveName.apply(null, arguments)
      }
    }
  }, [_c('md-input-container', [_c('md-input', {
    ref: "renameInput",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    model: {
      value: (_vm.editName),
      callback: function($$v) {
        _vm.editName = $$v
      },
      expression: "editName"
    }
  })], 1)], 1), _vm._v(" "), (_vm.autoKind) ? _c('span', [_vm._v(_vm._s(_vm.autoDetail)), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.autoDetail))])], 1) : _c('span', [_vm._v(_vm._s(_vm.getFormattedDate(_vm.version))), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom"
    }
  }, [_vm._v(_vm._s(_vm.getFormattedDate(_vm.version)))])], 1)]), _vm._v(" "), (_vm.editing && _vm.canEditName) ? _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveName.apply(null, arguments)
      }
    }
  }, [_c('md-icon', [_vm._v("check")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Save name")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editing && (_vm.user.uid === _vm.ownerUID || _vm.user.uid === _vm.version.creator) && _vm.activeProjectEntitled) ? _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        return _vm.deleteVersion(_vm.version.id)
      }
    }
  }, [_c('md-icon', [_vm._v("delete")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Delete Version")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editing && _vm.user.uid === _vm.ownerUID && _vm.activeProjectEntitled) ? _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        return _vm.promoteVersion(_vm.version.id)
      }
    }
  }, [_c('md-icon', [_vm._v("vertical_align_top")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Make Live")])], 1) : _vm._e(), _vm._v(" "), (!_vm.editing) ? _c('md-button', {
    staticClass: "md-icon-button md-list-action",
    on: {
      "click": function($event) {
        return _vm.setActiveVersion(_vm.version.id)
      }
    }
  }, [_c('md-icon', [_vm._v("launch")]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Show Version")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19d3a510","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/history/version.vue
// module id = 1210
// module chunks = 21